import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Entry = { name: string; enabled: boolean };
type Snapshot = { calendars: Entry[]; webhooks: Entry[] };

function Table({ title, rows, t }: { title: string; rows: Entry[]; t: (k: string) => string }) {
  return (
    <div className="mt-6">
      <h2 className="text-lg font-semibold text-brand-900">{title}</h2>
      <table className="mt-2 min-w-[24rem] rounded-md border border-slate-200 bg-white text-sm">
        <thead className="bg-slate-50 text-slate-700">
          <tr>
            <th className="px-4 py-2 text-left text-xs uppercase">{t("registry.col.name")}</th>
            <th className="px-4 py-2 text-left text-xs uppercase">{t("registry.col.enabled")}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.name} className="border-t border-slate-100">
              <td className="px-4 py-2 text-slate-700">{r.name}</td>
              <td className="px-4 py-2 text-slate-700">
                {r.enabled ? t("registry.enabled.yes") : t("registry.enabled.no")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function RegistryPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<Snapshot>("/api/v1/tenant/registry");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("registry.title")}</h1>
      {loading && <p className="mt-4 text-slate-500">{t("common.loading")}</p>}
      {error && <p className="mt-4 text-red-600">{error}</p>}
      {data && (
        <>
          <Table title={t("registry.calendars")} rows={data.calendars} t={t} />
          <Table title={t("registry.webhooks")} rows={data.webhooks} t={t} />
        </>
      )}
    </div>
  );
}
